import { useQuery } from "@tanstack/react-query";
import { Building2, X } from "lucide-react";
import { useState } from "react";
import { api } from "../lib/api";

export const HotelSuggest = ({ form, onPick }) => {
  const [q, setQ] = useState(form.hotel_name || "");
  const [open, setOpen] = useState(false);
  const { data = [] } = useQuery({
    queryKey: ["suggest", q, form.country_id, form.city_id],
    queryFn: () => api.get("/hotels/suggest", { params: { q, country_id: form.country_id, city_id: form.city_id } }).then((r) => r.data),
    enabled: open,
  });
  const pick = (h) => {
    setQ(h ? h.name : "");
    onPick(h);
    setOpen(false);
  };
  return (
    <div className="field relative">
      <span className="field-label">Hotel</span>
      <div className="relative">
        <Building2 className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-brand" strokeWidth={1.5} />
        <input
          className="field-input !pl-9 !pr-8"
          placeholder="Any hotel"
          value={q}
          onChange={(e) => { setQ(e.target.value); setOpen(true); if (!e.target.value) onPick(null); }}
          onFocus={() => setOpen(true)}
          onBlur={() => setTimeout(() => setOpen(false), 150)}
          data-testid="search-hotel-input"
        />
        {q && (
          <button type="button" className="absolute right-2 top-1/2 -translate-y-1/2 text-ink/40 hover:text-ink" onClick={() => pick(null)} data-testid="search-hotel-clear">
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
      {open && data.length > 0 && (
        <ul className="absolute left-0 right-0 top-full z-40 mt-1 overflow-hidden rounded-xl border border-brand/10 bg-white shadow-xl" data-testid="search-hotel-suggestions">
          {data.map((h) => (
            <li key={h.id}>
              <button type="button" onMouseDown={() => pick(h)} className="flex w-full flex-col px-4 py-2.5 text-left hover:bg-brand-light" data-testid={`suggest-${h.id}`}>
                <span className="text-sm text-ink">{h.name}</span>
                <span className="text-xs text-ink/50">{h.city}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
